export default function createLogbookCTA(): HTMLDivElement {
    const el = document.createElement('div');
    el.innerHTML = `
        <h2>All-in-One Access</h2>
        <p>Unlock full Logbook access plus Maps, Airports &amp; More.</p>
        <a href="https://foreflight.com/buy">Subscribe Now</a>
    `;
    el.className =
        'logbook-upsell ffmenu-item ffmenu-popup-ignore ffmenu-hover-ignore';
    return el;
}
